import React from 'react';

// Literal classes, so Tailwind keeps them.
const CLAMPS = {
  1: 'line-clamp-1',
  2: 'line-clamp-2',
  3: 'line-clamp-3',
};

export interface FolderClampedTextProps {
  text?: string | null;
  /** Lines shown before the text is cut ("…"). */
  lines?: keyof typeof CLAMPS;
  className?: string;
}

/**
 * KD-3910: text that wraps instead of widening its column, cut after `lines`
 * lines, in full on hover. A long word (a reference) breaks too.
 */
export default function FolderClampedText({
  text,
  lines = 2,
  className = '',
}: FolderClampedTextProps) {
  if (!text) {
    return null;
  }

  return (
    <span
      title={text}
      className={`${CLAMPS[lines]} [overflow-wrap:anywhere] ${className}`}
    >
      {text}
    </span>
  );
}
